export default __webpack_public_path__ + "img/4555ddbecc42a74c4aad84385a9376e3.svg";